// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"138":"688aaf89","276":"425a3f4c","832":"425a3f4c"}[chunkId] + ".chunk.css";
};